<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Identity Type Mapping</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form id="form" @submit.prevent="save"></form>
    <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
      <table
        style="width: auto !important"
        class="table table-bordered custom-table mb-0"
      >
        <thead class="thead-light">
          <tr>
            <th class="text-center" style="width: 150px">Code</th>
            <th class="text-center" style="width: 250px">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(code, i) in codes" :key="code.Id">
            <td class="text-center">
              <input
                form="form"
                type="text"
                v-model="code.Code"
                class="form-control height26 text-center"
                maxlength="10"
                required
              />
            </td>
            <td class="text-center" style="position: relative">
              <input
                form="form"
                type="text"
                v-model="code.Value"
                class="form-control height26 text-center"
                maxlength="50"
                required
              />
              <span
                @click="removeCode(i)"
                style="
                  position: absolute;
                  right: -8px;
                  top: 6px;
                  color: #ff0000;
                  cursor: pointer;
                "
              >
                <i class="fa fa-minus-circle"></i>
              </span>
            </td>
          </tr>

          <tr v-for="(newCode, i) in newCodes" :key="i">
            <td class="text-center">
              <input
                form="form"
                type="text"
                v-model="newCode.Code"
                class="form-control height26 text-center"
                maxlength="10"
                required
              />
            </td>
            <td class="text-center" style="position: relative">
              <input
                form="form"
                type="text"
                v-model="newCode.Value"
                class="form-control height26 text-center"
                maxlength="50"
                required
              />
              <span
                @click="removeNewCode(i)"
                style="
                  position: absolute;
                  right: -8px;
                  top: 6px;
                  color: #ff0000;
                  cursor: pointer;
                "
              >
                <i class="fa fa-minus-circle"></i>
              </span>
            </td>
          </tr>
          <tr>
            <td class="text-center" colspan="5">
              <button type="button" class="btn btn-primary" @click="addCode">
                <i class="fa fa-plus"></i> Add Code
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- /Form -->

    <!-- Save Button -->
    <div class="row mt-4">
      <div class="col-md-12">
        <button form="form" type="submit" class="btn btn-primary">
          <i class="fa fa-save"></i>
          Save
        </button>
      </div>
    </div>
    <!-- /Save Button -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      codes: [],
      newCodes: [],
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  methods: {
    addCode() {
      this.newCodes.push({
        Id: "",
        Code: "",
        Value: "",
      });
    },
    removeNewCode(index) {
      this.newCodes.splice(index, 1);
    },
    removeCode(index) {
      this.codes.splice(index, 1);
    },
    getIdentityTypeMapping() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getIdentityTypeMapping(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record) this.codes = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      //check duplicate code
      let allCodes = this.codes.concat(this.newCodes);
      for (let item of allCodes) {
        if (item.Code) {
          let records = allCodes.filter((c) => c.Code == item.Code);
          if (records && records.length > 1) {
            alert(`Code: ${item.Code} is duplicated.`);
            return;
          }
        }
      }

      let param = {
        Token: this.token,
        Codes: this.codes,
        NewCodes: this.newCodes,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveIdentityTypeMapping(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              this.codes = [];
              this.newCodes = [];
              this.getIdentityTypeMapping();
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },
  created() {
    if (this.role != "admin") this.$router.replace({ name: "home" });
    this.getIdentityTypeMapping();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Insurance/IdentityTypeMapping.vue